var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'input-number',
    { 'is-error': _vm.isError }
]},[_c('label',{domProps:{"textContent":_vm._s(_vm.label)}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"maxlength":_vm.maxlength},domProps:{"value":(_vm.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.value=$event.target.value},_vm.onInput],"keyup":function($event){_vm.isError = false}}})])}
var staticRenderFns = []

export { render, staticRenderFns }